import React from "react";
import { Eye, Radio, MousePointerClick } from "lucide-react";

const ITEMS = [
  ["impressions", "Impressions", Radio, "Kitni baar ad bheja / dikhaya gaya"],
  ["views", "Views", Eye, "Ad kam se kam 1 second screen par dikha"],
  ["clicks", "Clicks", MousePointerClick, "Ad par tap kiya gaya"],
];

// Owner-only lifetime counters from recorded ad events (no estimates, no Reach).
export function AdCounters({ counters, testid = "ad-counters" }) {
  if (!counters) return null;
  return (
    <div className="grid grid-cols-3 gap-2 mt-2" data-testid={testid}>
      {ITEMS.map(([k, label, Icon, hint]) => (
        <div key={k} title={hint} className="rounded-lg bg-slate-50 border border-slate-100 px-1.5 max-[374px]:px-1 sm:px-2 py-1.5 min-w-0">
          <div className="flex items-center gap-0.5 sm:gap-1 text-[8.5px] max-[374px]:text-[8px] tracking-normal sm:text-[10px] sm:tracking-wider uppercase font-semibold text-slate-500 whitespace-nowrap" data-testid={`${testid}-${k}-label`}><Icon className="w-3 h-3 flex-shrink-0" />{label}</div>
          <div className="text-sm font-bold text-slate-900" data-testid={`${testid}-${k}`}>{Number(counters[k] || 0).toLocaleString("en-IN")}</div>
        </div>
      ))}
    </div>
  );
}
